import axios from 'axios'

class LecturaDeAnalisis {
  static getAnalisis (numero) {
    const options = {
      baseURL: 'http://pcsonda/api/tecnocientifica/get'
    }
    const client = axios.create(options)
    const promise = client.get(`/${numero}`)
    return promise.then((response) => {
      return response.data
    })
      .catch(error => {
        console.log(error)
      })
  }

  static getAnalisisFecha (fecha) {
    // fecha formato aaaa-mm-dd
    const options = {
      baseURL: 'http://pcsonda/api/tecnocientifica/get'
    }
    const client = axios.create(options)
    const promise = client.get(`/${fecha}`)
    return promise.then((response) => {
      return response.data
    })
      .catch(error => {
        console.log(error)
      })
  }

  static changeAnalisis (viejo, nuevo) {
    const options = {
      baseURL: 'http://pcsonda/api/tecnocientifica/change?id='
    }
    const client = axios.create(options)
    const promise = client.get(`oldcode:${viejo};newcode:${nuevo}`)
    return promise.then((response) => {
      return response.data
    })
      .catch(error => {
        console.log(error)
      })
  }

  static getFakeAnalisis (numero) {
    return new Promise(function (resolve, reject) {
      const analisisCompleto = {
        Codigo: '000580418297 ',
        Etiqueta: `"${numero}"`,
        Producto: 'Cebada',
        FechaHora: '11/14/2019 5:33:52 PM',
        Mediciones:
              [{ Calada: '1',
                Medicion:
                [{ nombre: 'HUMEDAD', valor: '8.40206202923874', franja: '2' },
                  { nombre: 'MATERIA GRASA', valor: '9.45786583424621', franja: '2' },
                  { nombre: 'PROTEINA', valor: '7.38213208966767', franja: '2' },
                  { nombre: 'ALMIDON', valor: '63.0003448286935', franja: '2' },
                  { nombre: 'HUMEDAD', valor: '8.46632809324284', franja: '4' },
                  { nombre: 'MATERIA GRASA', valor: '8.30780235122054', franja: '4' },
                  { nombre: 'PROTEINA', valor: '6.27323043320074', franja: '4' },
                  { nombre: 'ALMIDON', valor: '63.3860588348394', franja: '4' },
                  { nombre: 'HUMEDAD', valor: '9.15537822864615', franja: '6' },
                  { nombre: 'MATERIA GRASA', valor: '7.57643942315996', franja: '6' },
                  { nombre: 'PROTEINA', valor: '7.36088202353063', franja: '6' },
                  { nombre: 'ALMIDON', valor: '65.5316249576662', franja: '6' }]
              },
              { Calada: '2',
                Medicion:
                [{ nombre: 'HUMEDAD', valor: '8.26006728738585', franja: '2' },
                  { nombre: 'MATERIA GRASA', valor: '10.5116930970597', franja: '2' },
                  { nombre: 'PROTEINA', valor: '6.58793319284336', franja: '2' },
                  { nombre: 'ALMIDON', valor: '61.9660205719938', franja: '2' },
                  { nombre: 'HUMEDAD', valor: '7.69033157179699', franja: '3' },
                  { nombre: 'MATERIA GRASA', valor: '10.6657972422212', franja: '3' },
                  { nombre: 'PROTEINA', valor: '6.41957363353663', franja: '3' },
                  { nombre: 'ALMIDON', valor: '61.8495936476248', franja: '3' },
                  { nombre: 'HUMEDAD', valor: '8.19451601246711', franja: '4' },
                  { nombre: 'MATERIA GRASA', valor: '10.5982409348956', franja: '4' },
                  { nombre: 'PROTEINA', valor: '6.73323495679535', franja: '4' },
                  { nombre: 'ALMIDON', valor: '62.0209357682429', franja: '4' },
                  { nombre: 'HUMEDAD', valor: '8.29012434356136', franja: '6' },
                  { nombre: 'MATERIA GRASA', valor: '9.44087867613666', franja: '6' },
                  { nombre: 'PROTEINA', valor: '6.75075380571601', franja: '6' },
                  { nombre: 'ALMIDON', valor: '63.7421762364833', franja: '6' }]
              },
              { Calada: '3',
                Medicion:
                [{ nombre: 'HUMEDAD', valor: '7.76329135293397', franja: '2' },
                  { nombre: 'MATERIA GRASA', valor: '9.99192637982378', franja: '2' },
                  { nombre: 'PROTEINA', valor: '6.78996938269062', franja: '2' },
                  { nombre: 'ALMIDON', valor: '62.6546004913958', franja: '2' },
                  { nombre: 'HUMEDAD', valor: '7.91462277201227', franja: '3' },
                  { nombre: 'MATERIA GRASA', valor: '9.58111938196591', franja: '3' },
                  { nombre: 'PROTEINA', valor: '6.85496098466543', franja: '3' },
                  { nombre: 'ALMIDON', valor: '63.5009437140876', franja: '3' },
                  { nombre: 'HUMEDAD', valor: '7.76684836149189', franja: '4' },
                  { nombre: 'MATERIA GRASA', valor: '10.0275527540155', franja: '4' },
                  { nombre: 'PROTEINA', valor: '6.85216947310568', franja: '4' },
                  { nombre: 'ALMIDON', valor: '62.4787598004669', franja: '4' },
                  { nombre: 'HUMEDAD', valor: '8.27196100976587', franja: '6' },
                  { nombre: 'MATERIA GRASA', valor: '8.38705516340933', franja: '6' },
                  { nombre: 'PROTEINA', valor: '6.64798741990615', franja: '6' },
                  { nombre: 'ALMIDON', valor: '65.3220910119935', franja: '6' }]
              }
              ] }
      if (analisisCompleto) {
        resolve(analisisCompleto)
      }
    })
  }
}

export default LecturaDeAnalisis
